import { render } from "./RefinedNav.vue?vue&type=template&id=064dc9a9"
import script from "./RefinedNav.vue?vue&type=script&lang=js"
export * from "./RefinedNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__